import { Button, Card, Col, Flex, Form, Input, Row, Select } from 'antd';
import { useCallback, useEffect, useState } from 'react';
import { notifyError, notifySuccess } from '../../../store/utils';
import { useNavigate, useParams } from 'react-router-dom';
import BranchSelect from '../../../lib/BranchSelect';
import { API } from '../../../api';

const BranchStaffUpdate = () => {
  const { memberNo } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  const fetchMember = useCallback(
    async (memberNo: string) => {
      try {
        const { result } = await API.get({ apiVersion: 'api' })(`/member/branch/staff/${memberNo}`);
        const roles = result?.data?.roles || [];
        form.setFieldsValue({
          branchNo: roles?.[0]?.courierBranch?.no,
          email: result?.data?.email,
          fname: result?.data?.firstName,
          lName: result?.data?.lastName,
          phone1: result?.data?.phone,
        });
      } catch (error: any) {
        notifyError(error.message);
      }
    },
    [form]
  );

  const onFinish = useCallback(
    async (values: any) => {
      setLoading(true);
      try {
        if (memberNo) {
          await API.put({ apiVersion: 'api' })(`/member/branch/staff/update/${memberNo}`, values);
          notifySuccess('Амжилттай хадгаллаа');
        } else {
          await API.post({ apiVersion: 'api' })(`/member/branch/staff/create`, values);
          notifySuccess('Амжилттай хадгаллаа');
          navigate('/settings/branch/staff');
        }
      } catch (error: any) {
        notifyError(error.message);
      } finally {
        setLoading(false);
      }
    },
    [memberNo]
  );

  useEffect(() => {
    if (memberNo) {
      fetchMember(memberNo);
    }
  }, [memberNo]);

  return (
    <Card title={`Ажилтаны жагсаалт`}>
      <Row>
        <Col span={12} offset={6}>
          <Form
            form={form}
            onFinish={onFinish}
            layout="vertical"
            initialValues={{
              role: 'BRANCH_STAFF',
            }}
          >
            <Form.Item
              name="branchNo"
              label="Салбар"
              rules={[{ required: true, message: 'Салбар сонгоно уу' }]}
            >
              <BranchSelect disabled={!!memberNo} allowClear showSearch />
            </Form.Item>
            <Form.Item
              name="email"
              label="Нэвтрэх нэр"
              rules={[{ required: true, message: 'Нэвтрэх нэр оруулна уу' }]}
            >
              <Input disabled={!!memberNo} placeholder="Нэвтрэх нэр" />
            </Form.Item>
            <Form.Item
              name="password"
              label="Нууц үг"
              rules={[{ required: memberNo ? false : true, message: 'Нууц үг оруулна уу' }]}
            >
              <Input placeholder="Нууц үг" />
            </Form.Item>
            <Form.Item
              name="fname"
              label="Нэр"
              rules={[{ required: true, message: 'Нэр оруулна уу' }]}
            >
              <Input placeholder="Нэр" />
            </Form.Item>
            <Form.Item
              name="phone1"
              label="Утас"
              rules={[{ required: true, message: 'Утас оруулна уу' }]}
            >
              <Input placeholder="Утас" />
            </Form.Item>
            <Form.Item
              name="role"
              label="Эрхийн түвшин"
              rules={[{ required: true, message: 'Эрхийн түвшин сонгоно уу' }]}
            >
              <Select options={[{ label: 'Салбарын ажилтан', value: 'BRANCH_STAFF' }]} />
            </Form.Item>
            <Form.Item>
              <Flex justify="end" gap={24}>
                <Button onClick={() => navigate(-1)} htmlType="button">
                  Буцах
                </Button>
                <Button loading={loading} type="primary" htmlType="submit">
                  Хадгалах
                </Button>
              </Flex>
            </Form.Item>
          </Form>
        </Col>
      </Row>
    </Card>
  );
};

export default BranchStaffUpdate;
